var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeaturedSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 212,
  height: 125,
  viewBox: "0 0 212 125",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_11899_14180)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 7.29527C0 3.26621 3.2662 0 7.29526 0H204.267C208.296 0 211.562 3.2662 211.562 7.29526V116.724C211.562 120.753 208.296 124.019 204.267 124.019H7.29526C3.2662 124.019 0 120.753 0 116.724V7.29527Z",
  fill: "url(#paint0_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 7.29527C0 3.26621 3.2662 0 7.29526 0H204.267C208.296 0 211.562 3.2662 211.562 7.29526V116.724C211.562 120.753 208.296 124.019 204.267 124.019H7.29526C3.2662 124.019 0 120.753 0 116.724V7.29527Z",
  fill: "url(#paint1_linear_11899_14180)",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-2-outside-1_11899_14180",
  maskUnits: "userSpaceOnUse",
  x: 39.25,
  y: -12.2656,
  width: 134,
  height: 180,
  fill: "black"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  x: 39.25,
  y: -12.2656,
  width: 134,
  height: 180
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.4683 24.8551C94.4683 23.1316 93.0711 21.7344 91.3476 21.7344H80.21C76.3661 21.7344 73.25 24.8505 73.25 28.6943V130.073C73.25 131.796 74.6472 133.194 76.3707 133.194H135.693C137.416 133.194 138.814 131.796 138.814 130.073V28.6943C138.814 24.8505 135.697 21.7344 131.854 21.7344H120.123C118.399 21.7344 117.002 23.1316 117.002 24.8551V25.3154C117.002 26.562 115.992 27.5727 114.745 27.5727H96.7256C95.4789 27.5727 94.4683 26.562 94.4683 25.3154V24.8551Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.4683 24.8551C94.4683 23.1316 93.0711 21.7344 91.3476 21.7344H80.21C76.3661 21.7344 73.25 24.8505 73.25 28.6943V130.073C73.25 131.796 74.6472 133.194 76.3707 133.194H135.693C137.416 133.194 138.814 131.796 138.814 130.073V28.6943C138.814 24.8505 135.697 21.7344 131.854 21.7344H120.123C118.399 21.7344 117.002 23.1316 117.002 24.8551V25.3154C117.002 26.562 115.992 27.5727 114.745 27.5727H96.7256C95.4789 27.5727 94.4683 26.562 94.4683 25.3154V24.8551Z",
  fill: "white",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.21 55.5398H91.3476V-12.0711H80.21V55.5398ZM107.055 28.6943C107.055 43.5207 95.0363 55.5398 80.21 55.5398V-12.0711C57.6958 -12.0711 39.4445 6.18025 39.4445 28.6943H107.055ZM107.055 130.073V28.6943H39.4445V130.073H107.055ZM135.693 99.3882H76.3707V166.999H135.693V99.3882ZM105.008 28.6943V130.073H172.619V28.6943H105.008ZM131.854 55.5398C117.027 55.5398 105.008 43.5207 105.008 28.6943H172.619C172.619 6.18023 154.368 -12.0711 131.854 -12.0711V55.5398ZM120.123 55.5398H131.854V-12.0711H120.123V55.5398ZM83.1967 24.8551V25.3154H150.808V24.8551H83.1967ZM83.1967 25.3154C83.1967 7.89181 97.3213 -6.2328 114.745 -6.2328V61.3781C134.662 61.3781 150.808 45.2322 150.808 25.3154H83.1967ZM114.745 -6.2328H96.7256V61.3781H114.745V-6.2328ZM96.7256 -6.2328C114.149 -6.2328 128.274 7.89175 128.274 25.3154H60.6629C60.6629 45.2323 76.8087 61.3781 96.7256 61.3781V-6.2328ZM128.274 25.3154V24.8551H60.6629V25.3154H128.274ZM120.123 -12.0711C99.7291 -12.0711 83.1967 4.46132 83.1967 24.8551H150.808C150.808 41.8018 137.07 55.5398 120.123 55.5398V-12.0711ZM135.693 166.999C156.087 166.999 172.619 150.467 172.619 130.073H105.008C105.008 113.126 118.746 99.3882 135.693 99.3882V166.999ZM39.4445 130.073C39.4445 150.467 55.977 166.999 76.3707 166.999V99.3882C93.3174 99.3882 107.055 113.126 107.055 130.073H39.4445ZM91.3476 55.5398C74.4009 55.5398 60.6629 41.8018 60.6629 24.8551H128.274C128.274 4.46135 111.741 -12.0711 91.3476 -12.0711V55.5398Z",
  fill: "url(#paint2_linear_11899_14180)",
  fillOpacity: 0.1,
  mask: "url(#path-2-outside-1_11899_14180)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-4-inside-2_11899_14180",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.911 24.7617C92.911 23.9306 92.2372 23.2568 91.4061 23.2568H80.3863C77.0836 23.2568 74.4062 25.9342 74.4062 29.2369V124.85C74.4062 125.681 75.08 126.355 75.9111 126.355H135.62C136.451 126.355 137.124 125.681 137.124 124.85V29.2369C137.124 25.9342 134.447 23.2568 131.144 23.2568H120.171C119.34 23.2568 118.666 23.9306 118.666 24.7617V25.6207C118.666 27.4907 117.15 29.0066 115.28 29.0066H96.2969C94.4269 29.0066 92.911 27.4907 92.911 25.6207V24.7617Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.911 24.7617C92.911 23.9306 92.2372 23.2568 91.4061 23.2568H80.3863C77.0836 23.2568 74.4062 25.9342 74.4062 29.2369V124.85C74.4062 125.681 75.08 126.355 75.9111 126.355H135.62C136.451 126.355 137.124 125.681 137.124 124.85V29.2369C137.124 25.9342 134.447 23.2568 131.144 23.2568H120.171C119.34 23.2568 118.666 23.9306 118.666 24.7617V25.6207C118.666 27.4907 117.15 29.0066 115.28 29.0066H96.2969C94.4269 29.0066 92.911 27.4907 92.911 25.6207V24.7617Z",
  fill: "url(#paint3_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.3863 23.453H91.4061V23.0607H80.3863V23.453ZM74.6024 29.2369C74.6024 26.0425 77.1919 23.453 80.3863 23.453V23.0607C76.9753 23.0607 74.2101 25.8259 74.2101 29.2369H74.6024ZM74.6024 124.85V29.2369H74.2101V124.85H74.6024ZM135.62 126.159H75.9111V126.551H135.62V126.159ZM136.928 29.2369V124.85H137.321V29.2369H136.928ZM131.144 23.453C134.339 23.453 136.928 26.0425 136.928 29.2369H137.321C137.321 25.8259 134.555 23.0607 131.144 23.0607V23.453ZM120.171 23.453H131.144V23.0607H120.171V23.453ZM118.47 24.7617V25.6207H118.862V24.7617H118.47ZM118.47 25.6207C118.47 27.3824 117.042 28.8105 115.28 28.8105V29.2027C117.258 29.2027 118.862 27.599 118.862 25.6207H118.47ZM115.28 28.8105H96.2969V29.2027H115.28V28.8105ZM96.2969 28.8105C94.5352 28.8105 93.1071 27.3824 93.1071 25.6207H92.7148C92.7148 27.599 94.3186 29.2027 96.2969 29.2027V28.8105ZM93.1071 25.6207V24.7617H92.7148V25.6207H93.1071ZM120.171 23.0607C119.231 23.0607 118.47 23.8223 118.47 24.7617H118.862C118.862 24.0389 119.448 23.453 120.171 23.453V23.0607ZM135.62 126.551C136.559 126.551 137.321 125.789 137.321 124.85H136.928C136.928 125.573 136.342 126.159 135.62 126.159V126.551ZM74.2101 124.85C74.2101 125.789 74.9717 126.551 75.9111 126.551V126.159C75.1883 126.159 74.6024 125.573 74.6024 124.85H74.2101ZM91.4061 23.453C92.1289 23.453 92.7148 24.0389 92.7148 24.7617H93.1071C93.1071 23.8223 92.3455 23.0607 91.4061 23.0607V23.453Z",
  fill: "white",
  fillOpacity: 0.1,
  mask: "url(#path-4-inside-2_11899_14180)"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M76.6719 99.1328H135.57V100.999C135.57 102.374 134.456 103.488 133.081 103.488H79.1606C77.7861 103.488 76.6719 102.374 76.6719 100.999V99.1328Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.2344 94.1543H141.991V96.6429C141.991 98.0174 140.876 99.1317 139.502 99.1317H72.7231C71.3486 99.1317 70.2344 98.0174 70.2344 96.6429V94.1543Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("rect", {
  x: 66.6562,
  y: 56.3545,
  width: 78.9347,
  height: 37.81,
  rx: 2.48875,
  fill: "white"
})), /*#__PURE__*/React.createElement("rect", {
  x: 62.9141,
  y: 47.4922,
  width: 86.4814,
  height: 41.425,
  rx: 2.48875,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63.0178,
  y: 47.5959,
  width: 86.274,
  height: 41.2176,
  rx: 2.38505,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.207395
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 54.1289,
  width: 7.82748,
  height: 7.82736,
  rx: 0.568993,
  fill: "url(#paint4_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 54.1289,
  width: 7.82748,
  height: 7.82736,
  rx: 0.568993,
  fill: "black",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 126.695,
  y: 54.1289,
  width: 14.4058,
  height: 1.4168,
  rx: 0.284497,
  fill: "url(#paint5_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 68.5928,
  width: 37.6126,
  height: 3.31824,
  rx: 0.414791,
  fill: "url(#paint6_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 68.5928,
  width: 37.6126,
  height: 3.31824,
  rx: 0.414791,
  fill: "black",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 75.2295,
  width: 50.1493,
  height: 1.24434,
  rx: 0.284497,
  fill: "url(#paint7_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 78.1328,
  width: 54.0797,
  height: 1.24434,
  rx: 0.284497,
  fill: "url(#paint8_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.2109,
  y: 81.0361,
  width: 38.7705,
  height: 1.24434,
  rx: 0.284497,
  fill: "url(#paint9_linear_11899_14180)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddddddd_11899_14180)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 162.477,
  y: 26.5488,
  width: 20.7465,
  height: 19.6614,
  rx: 1.87282,
  fill: "white",
  fillOpacity: 0.08,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("rect", {
  x: 162.568,
  y: 26.6406,
  width: 20.5629,
  height: 19.4778,
  rx: 1.78102,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.183586,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.366 39.0605H177.353V34.7839C177.353 32.2977 175.337 30.2822 172.851 30.2822C170.365 30.2822 168.349 32.2977 168.349 34.7839V39.0606H167.336C166.715 39.0605 166.211 39.5644 166.211 40.186C166.211 40.8075 166.715 41.3114 167.336 41.3114H178.366C178.987 41.3114 179.491 40.8075 179.491 40.186C179.491 39.5644 178.987 39.0605 178.366 39.0605Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.977 41.3115V41.5329C173.977 41.9616 173.474 42.4775 172.852 42.4775C172.23 42.4775 171.727 41.9616 171.727 41.5329V41.3115",
  fill: "white",
  fillOpacity: 0.7
})), /*#__PURE__*/React.createElement("rect", {
  x: 174.914,
  y: 30.3408,
  width: 2.93297,
  height: 2.93293,
  rx: 1.46646,
  fill: "white",
  fillOpacity: 0.96
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 176.384,
  cy: 31.8073,
  rx: 1.18912,
  ry: 1.1891,
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_ddddddd_11899_14180)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30.6641,
  y: 12.4443,
  width: 20.7465,
  height: 19.6614,
  rx: 1.87282,
  fill: "white",
  fillOpacity: 0.25,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.7559,
  y: 12.5361,
  width: 20.5629,
  height: 19.4778,
  rx: 1.78102,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.183586,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.5532 24.956H45.5403V20.6794C45.5403 18.1932 43.5248 16.1777 41.0385 16.1777C38.5522 16.1777 36.5368 18.1932 36.5368 20.6794V24.9561H35.5239C34.9023 24.956 34.3984 25.4599 34.3984 26.0815C34.3984 26.703 34.9023 27.2069 35.5239 27.2069H46.5532C47.1748 27.2069 47.6786 26.703 47.6786 26.0815C47.6787 25.4599 47.1748 24.956 46.5532 24.956Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.1649 27.207V27.4284C42.1649 27.8571 41.6611 28.373 41.0395 28.373C40.4179 28.373 39.9141 27.8571 39.9141 27.4284V27.207",
  fill: "white",
  fillOpacity: 0.7
})), /*#__PURE__*/React.createElement("rect", {
  x: 43.1172,
  y: 16.2354,
  width: 2.93297,
  height: 2.93293,
  rx: 1.46646,
  fill: "white",
  fillOpacity: 0.96
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.5876,
  cy: 17.7018,
  rx: 1.18912,
  ry: 1.1891,
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_ddddddd_11899_14180)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 17.7812,
  y: 83.3701,
  width: 20.7465,
  height: 19.6614,
  rx: 1.87282,
  fill: "white",
  fillOpacity: 0.05,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.873,
  y: 83.4619,
  width: 20.5629,
  height: 19.4778,
  rx: 1.78102,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.183586,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.5538 95.8818C32.5538 95.9391 32.6002 95.9855 32.6575 95.9855H33.6704C34.2347 95.9855 34.6921 96.443 34.6921 97.0073C34.6921 97.5715 34.2347 98.029 33.6704 98.029H22.6411C22.0768 98.029 21.6193 97.5715 21.6193 97.0073C21.6193 96.443 22.0768 95.9855 22.6411 95.9856H23.654C23.7112 95.9856 23.7577 95.9391 23.7577 95.8819V91.6052C23.7577 89.1762 25.7267 87.2072 28.1557 87.2072C30.5848 87.2072 32.5538 89.1762 32.5538 91.6052V95.8818Z",
  stroke: "white",
  strokeWidth: 0.207395,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-32-inside-3_11899_14180",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.2821 98.1328V98.3542C29.2821 98.7828 28.7782 99.2988 28.1567 99.2988C27.5351 99.2988 27.0312 98.7828 27.0312 98.3542V98.1328"
})), /*#__PURE__*/React.createElement("path", {
  d: "M29.4895 98.1328C29.4895 98.0183 29.3967 97.9254 29.2821 97.9254C29.1676 97.9254 29.0747 98.0183 29.0747 98.1328H29.4895ZM27.2386 98.1328C27.2386 98.0183 27.1458 97.9254 27.0312 97.9254C26.9167 97.9254 26.8239 98.0183 26.8239 98.1328H27.2386ZM29.0747 98.1328V98.3542H29.4895V98.1328H29.0747ZM29.0747 98.3542C29.0747 98.4919 28.989 98.676 28.8141 98.8328C28.6433 98.9859 28.4098 99.0914 28.1567 99.0914V99.5062C28.5251 99.5062 28.8544 99.3537 29.0909 99.1417C29.3233 98.9333 29.4895 98.6451 29.4895 98.3542H29.0747ZM28.1567 99.0914C27.9035 99.0914 27.6701 98.9859 27.4993 98.8328C27.3244 98.676 27.2386 98.4919 27.2386 98.3542H26.8239C26.8239 98.6451 26.99 98.9333 27.2224 99.1417C27.459 99.3537 27.7883 99.5062 28.1567 99.5062V99.0914ZM27.2386 98.3542V98.1328H26.8239V98.3542H27.2386Z",
  fill: "white",
  mask: "url(#path-32-inside-3_11899_14180)"
})), /*#__PURE__*/React.createElement("rect", {
  x: 30.2812,
  y: 87.1641,
  width: 2.93297,
  height: 2.93293,
  rx: 1.46646,
  fill: "white",
  fillOpacity: 0.96
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 31.7516,
  cy: 88.6305,
  rx: 1.18912,
  ry: 1.1891,
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_ddddddd_11899_14180)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -17.4688,
  y: 41.8955,
  width: 20.7465,
  height: 19.6614,
  rx: 1.87282,
  fill: "white",
  fillOpacity: 0.25,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("rect", {
  x: -17.377,
  y: 41.9873,
  width: 20.5629,
  height: 19.4778,
  rx: 1.78102,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.183586,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_ddddddd_11899_14180)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 172.805,
  y: 84.2051,
  width: 20.7465,
  height: 19.6614,
  rx: 1.87282,
  fill: "white",
  fillOpacity: 0.25,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("rect", {
  x: 172.896,
  y: 84.2969,
  width: 20.5629,
  height: 19.4778,
  rx: 1.78102,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.183586,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.694 96.7168H187.681V92.4402C187.681 89.9539 185.665 87.9385 183.179 87.9385C180.693 87.9385 178.677 89.9539 178.677 92.4402V96.7168H177.664C177.043 96.7168 176.539 97.2206 176.539 97.8422C176.539 98.4637 177.043 98.9676 177.664 98.9676H188.694C189.315 98.9676 189.819 98.4637 189.819 97.8422C189.819 97.2206 189.315 96.7168 188.694 96.7168Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.306 98.9678V99.1892C184.306 99.6178 183.802 100.134 183.18 100.134C182.559 100.134 182.055 99.6178 182.055 99.1892V98.9678",
  fill: "white",
  fillOpacity: 0.7
})), /*#__PURE__*/React.createElement("rect", {
  x: 185.266,
  y: 88,
  width: 2.93297,
  height: 2.93293,
  rx: 1.46646,
  fill: "white",
  fillOpacity: 0.96
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 186.736,
  cy: 89.4664,
  rx: 1.18912,
  ry: 1.1891,
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_ddddddd_11899_14180)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 208.117,
  y: 5.80664,
  width: 20.7465,
  height: 19.6614,
  rx: 1.87282,
  fill: "white",
  fillOpacity: 0.25,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("rect", {
  x: 208.209,
  y: 5.89843,
  width: 20.5629,
  height: 19.4778,
  rx: 1.78102,
  stroke: "#FCAC8F",
  strokeOpacity: 0.3,
  strokeWidth: 0.183586,
  shapeRendering: "crispEdges"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddddddd_11899_14180",
  x: 140.287,
  y: 26.2715,
  width: 65.1285,
  height: 69.8643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 27.7365
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.0946
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11.6493
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.57653
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_11899_14180",
  result: "effect2_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.10204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.49629
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_11899_14180",
  result: "effect3_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.32838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.38683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_11899_14180",
  result: "effect4_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.94156
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.832096
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_11899_14180",
  result: "effect5_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.138683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.45098 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_11899_14180",
  result: "effect6_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.832096
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.277365
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_11899_14180",
  result: "effect7_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect7_dropShadow_11899_14180",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_ddddddd_11899_14180",
  x: 8.47483,
  y: 12.167,
  width: 65.1285,
  height: 69.8643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 27.7365
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.0946
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11.6493
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.57653
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_11899_14180",
  result: "effect2_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.10204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.49629
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_11899_14180",
  result: "effect3_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.32838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.38683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_11899_14180",
  result: "effect4_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.94156
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.832096
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_11899_14180",
  result: "effect5_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.138683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.45098 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_11899_14180",
  result: "effect6_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.832096
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.277365
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_11899_14180",
  result: "effect7_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect7_dropShadow_11899_14180",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_ddddddd_11899_14180",
  x: -4.40798,
  y: 83.0928,
  width: 65.1285,
  height: 69.8643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 27.7365
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.0946
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11.6493
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.57653
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_11899_14180",
  result: "effect2_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.10204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.49629
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_11899_14180",
  result: "effect3_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.32838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.38683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_11899_14180",
  result: "effect4_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.94156
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.832096
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_11899_14180",
  result: "effect5_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.138683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.45098 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_11899_14180",
  result: "effect6_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.832096
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.277365
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_11899_14180",
  result: "effect7_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect7_dropShadow_11899_14180",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_ddddddd_11899_14180",
  x: -39.658,
  y: 41.6181,
  width: 65.1285,
  height: 69.8643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 27.7365
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.0946
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11.6493
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.57653
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_11899_14180",
  result: "effect2_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.10204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.49629
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_11899_14180",
  result: "effect3_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.32838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.38683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_11899_14180",
  result: "effect4_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.94156
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.832096
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_11899_14180",
  result: "effect5_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.138683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.45098 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_11899_14180",
  result: "effect6_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.832096
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.277365
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_11899_14180",
  result: "effect7_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect7_dropShadow_11899_14180",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_ddddddd_11899_14180",
  x: 150.615,
  y: 83.9277,
  width: 65.1285,
  height: 69.8643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 27.7365
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.0946
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11.6493
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.57653
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_11899_14180",
  result: "effect2_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.10204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.49629
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_11899_14180",
  result: "effect3_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.32838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.38683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_11899_14180",
  result: "effect4_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.94156
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.832096
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_11899_14180",
  result: "effect5_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.138683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.45098 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_11899_14180",
  result: "effect6_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.832096
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.277365
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_11899_14180",
  result: "effect7_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect7_dropShadow_11899_14180",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_ddddddd_11899_14180",
  x: 185.928,
  y: 5.52928,
  width: 65.1285,
  height: 69.8643,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 27.7365
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 11.0946
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 11.6493
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.57653
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_11899_14180",
  result: "effect2_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.10204
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.49629
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_11899_14180",
  result: "effect3_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.32838
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.38683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_11899_14180",
  result: "effect4_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.94156
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.832096
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_11899_14180",
  result: "effect5_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.138683
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.447059 0 0 0 0 0.447059 0 0 0 0 0.45098 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_11899_14180",
  result: "effect6_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.832096
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.277365
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0823529 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_11899_14180",
  result: "effect7_dropShadow_11899_14180"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect7_dropShadow_11899_14180",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_11899_14180",
  x1: 0,
  y1: 0,
  x2: 224.14,
  y2: 29.9767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5614B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "#F5614B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA7545"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_11899_14180",
  x1: 106.41,
  y1: -5.4304,
  x2: 105.776,
  y2: 124.019,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0206989,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43926,
  stopOpacity: 0.427408
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_11899_14180",
  x1: 106.032,
  y1: 21.7344,
  x2: 106.032,
  y2: 133.194,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_11899_14180",
  x1: 84.1354,
  y1: 18.0134,
  x2: 154.57,
  y2: 35.4899,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0044245,
  stopColor: "#FA7545"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.867138,
  stopColor: "#F5614B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_11899_14180",
  x1: 71.2109,
  y1: 54.1289,
  x2: 79.6005,
  y2: 54.7867,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5614B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "#F5614B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA7545"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_11899_14180",
  x1: 122.628,
  y1: 53.6225,
  x2: 125.337,
  y2: 61.8994,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.140625,
  stopColor: "#434344"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.635417,
  stopColor: "#535353"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.895833,
  stopColor: "#5B5B5B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_11899_14180",
  x1: 71.2109,
  y1: 68.5928,
  x2: 93.8743,
  y2: 88.733,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5614B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "#F5614B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA7545"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_11899_14180",
  x1: 57.0509,
  y1: 74.7847,
  x2: 57.7109,
  y2: 82.7784,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.130208,
  stopColor: "#89898A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.864583,
  stopColor: "#B9B9B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_11899_14180",
  x1: 55.9411,
  y1: 77.688,
  x2: 56.5538,
  y2: 85.6893,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.130208,
  stopColor: "#89898A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.864583,
  stopColor: "#B9B9B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_11899_14180",
  x1: 60.2638,
  y1: 80.5913,
  x2: 61.1137,
  y2: 88.5488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.130208,
  stopColor: "#89898A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.864583,
  stopColor: "#B9B9B9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11899_14180"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 7.29527C0 3.26621 3.2662 0 7.29526 0H204.267C208.296 0 211.562 3.2662 211.562 7.29526V116.724C211.562 120.753 208.296 124.019 204.267 124.019H7.29526C3.2662 124.019 0 120.753 0 116.724V7.29527Z",
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeaturedSvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/FeaturedSVG.38ca4dc2.svg";